import styled, { withTheme } from 'styled-components'

const TFButton = styled.button`
  height: 40px;
  background: #666;
  background-image: -webkit-linear-gradient(top, #666, #000);
  background-image: -moz-linear-gradient(top, #666, #000);
  background-image: -ms-linear-gradient(top, #666, #000);
  background-image: -o-linear-gradient(top, #666, #000);
  background-image: linear-gradient(to bottom, #666, #000);
  -webkit-border-radius: 5;
  -moz-border-radius: 5;
  border-radius: 5px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  padding: 8px 20px 8px 20px;
  text-decoration: none;
  border: none;
  display: block;
  text-align: center;
  margin: 30px auto 0;
  width: 300px;
  &:hover {
    background: #000;
    background-image: -webkit-linear-gradient(top, #000, #666);
    background-image: -moz-linear-gradient(top, #000, #666);
    background-image: -ms-linear-gradient(top, #000, #666);
    background-image: -o-linear-gradient(top, #000, #666);
    background-image: linear-gradient(to bottom, #000, #666);
    text-decoration: none;
  }
  &:focus {
  }
  &:active {
  }
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
`
export default withTheme(TFButton)



// WEBPACK FOOTER //
// ./src/components/TF/Button.js